import _ from 'lodash'
import { Map, List, isImmutable, fromJS } from 'immutable'
import { getParentIdInModal, getValueForMode, LAYOUT_MODE } from '../constants/toUnits'
import { getParams, getState, processRuleCondition } from './processPortalRules'
import { getPreviewDynamicData } from './projectAxios'
import { COND_RULES_SET_STATUS } from '../store/project/actionTypes'
import { LIST_BASED_FIELDS } from '../constants/LIST_BASED_FIELDS'
import { getElementDataRoot } from '../constants/getElementDataRoot'
import { getColumnSubPath } from './powerTableUtils'
import { option } from './common'
import { IS_SERVER } from '../constants/ssr'
import { TAB_TYPES } from './tab-utils'
import { getPageUID } from './getValueByType'
import { setCondRulesStatus } from '../store/project/actions'
import defaultCheckoutCaptions from '../constants/echeckout-captions'
import { isEmailValid } from '../lib/isEmailValid'

const COMPLEX_ELEMENT_TYPES = ['TextReview']

export const CHECKOUT_FIELD_OPTIONS = [
  option('Country', 'country'),
  option('Email', 'email'),
  option('First Name', 'firstName'),
  option('Last Name', 'lastName'),
  option('Company Name', 'companyName'),
  option('Company Number', 'companyNumber'),
  option('Street Address', 'streetAddress'),
  option('Address 2', 'address2'),
  option('City', 'city'),
  option('State', 'state'),
  option('Zip', 'zip'),
  option('Phone', 'phone'),
  option('Same As Shipping', 'sameAsShipping'),
]

export const processCheckoutValueRules = (target, field, isIgnoreSuccessStatus) => (dispatch, getAppState) => {
  let state = getAppState()
  let portalState = getState(state)
  let path = ['eCommerce', 'checkoutForm', target, field]

  const IRules = state.getIn(
    ['project', 'Settings', 'eCommerce', 'pages', 'e_checkout', 'Props', target, 'rules', field],
    List()
  )
  const rules = IRules.toJS()

  let isError = false,
    errorMessage = ''
  let errorCode = ''

  const params = getParams(state)
  const smartVParams = typeof window !== 'undefined' ? _.get(getPreviewDynamicData(), 'svParams', {}) : {}

  if (_.size(rules) > 0) {
    for (let i = 0; i < rules.length; i++) {
      _.each(rules[i].conditions, (cond) => {
        let val = _.get(cond, 'field.value', '')
        val = `eCommerce:checkoutForm:${target === 'payment' ? 'billing' : target}:${field}`
        //String(val).replace(':value', `:${colID}`);
        _.set(cond, 'field.value', val)
      })
      const ruleRunResult = processRuleCondition(
        rules[i].conditions,
        portalState,
        params,
        smartVParams,
        null,
        {},
        false,
        {},
        {},
        state
      )
      if (!ruleRunResult) {
        isError = true
        errorMessage = rules[i].message
        break
      }
    }
  }
  let labelField = _.get(
    _.find(CHECKOUT_FIELD_OPTIONS, (v) => v.value === 'field'),
    'label',
    ''
  )
  let ruleStatus = {}

  if (isError) {
    ruleStatus.status = 'error'
    ruleStatus.error = errorMessage
    ruleStatus.errorCode = errorCode
  } else if (field === 'email') {
    const invalidCaption =
      state.getIn([
        'project',
        'Settings',
        'eCommerce',
        'pages',
        'e_checkout',
        'Props',
        'captions',
        'Errors',
        'Is mandatory',
      ]) || defaultCheckoutCaptions['Errors'].items['Is mandatory']
    const value = state.getIn(path, '')
    if (!isEmailValid(value)) {
      isError = true
      ruleStatus.status = 'error'
      ruleStatus.error = errorMessage = invalidCaption
      ruleStatus.errorCode = 'mandatory'
    }
  } else {
    ruleStatus.status = 'success'
    ruleStatus.error = ''
    ruleStatus.errorCode = ''
  }
  if (isIgnoreSuccessStatus && ruleStatus.status == 'success') {
    dispatch(
      setCondRulesStatus(['formFieldStatuses', ...path], {
        status: 'initial',
      })
    )
  } else {
    dispatch(setCondRulesStatus(['formFieldStatuses', ...path], ruleStatus))
  }

  return {
    ruleStatus: ruleStatus,
    status: ruleStatus.status,
    error: labelField + ' ' + errorMessage,
    errorCode,
  }
}

export const processTableValueRules =
  (uid, colID, path, index, value, isIgnoreSuccessStatus, component, isChanged) => (dispatch, getAppState) => {
    let state = getAppState()
    let portalState = getState(state)
    let fixedPath
    if (path[1] && String(path[1]).indexOf('##') > -1) {
      fixedPath = [path[0], ...String(path[1]).split('##')]
    } else {
      fixedPath = path
    }
    if (value !== undefined) {
      portalState = _.set(portalState, [...fixedPath, colID, index], value)
    }
    let columns = component.getIn(['props', 'columns'], List()).toJS()
    if (!columns.length) {
      columns = component.getIn(['Props', 'columns'], List()).toJS()
    }

    const mandatoryProjectCaption = state.getIn(['project', 'Settings', 'captions', 'Mandatory'], 'is mandatory field')
    const mandatoryCaption = component.getIn(['props', 'captions', 'Mandatory']) || mandatoryProjectCaption

    const col = _.get(columns, getColumnSubPath(columns, colID), {})
    const rules = _.get(col, 'meta.valueRules', [])

    let isError = false,
      errorMessage = ''
    let errorCode = ''

    const params = getParams(state)
    const smartVParams = typeof window !== 'undefined' ? _.get(getPreviewDynamicData(), 'svParams', {}) : {}

    if (_.get(col, ['meta', 'mandatory'])) {
      if (!value) {
        isError = true
        errorMessage = mandatoryCaption
        errorCode = 'mandatory'
      }
    }

    if (_.size(rules) > 0) {
      for (let i = 0; i < rules.length; i++) {
        _.each(rules[i].conditions, (cond) => {
          let val = _.get(cond, 'field.value', '')
          val = String(val).replace(':value', `:${colID}`)
          _.set(cond, 'field.value', val)
          if (value !== undefined) {
            portalState = _.set(portalState, [...val.split(':'), index], value)
          }
        })
        // console.log('portalState >>> ', portalState);
        const ruleRunResult = processRuleCondition(
          rules[i].conditions,
          portalState,
          params,
          smartVParams,
          index,
          {},
          false,
          {},
          {},
          state
        )
        if (!ruleRunResult) {
          isError = true
          errorMessage = rules[i].message
          break
        }
      }
    }
    let labelField = col.Header || 'Col'
    let ruleStatus = {}
    if (isError) {
      ruleStatus.status = 'error'
      ruleStatus.error = errorMessage
      ruleStatus.errorCode = errorCode
    } else {
      ruleStatus.status = 'success'
      ruleStatus.error = ''
      ruleStatus.errorCode = ''
    }
    if (isIgnoreSuccessStatus && ruleStatus.status == 'success') {
      dispatch(
        setCondRulesStatus(
          ['formFieldStatuses', ...path, col.id, index],
          {
            status: 'initial',
            isChanged: isChanged,
          },
          isChanged
        )
      )
    } else {
      dispatch(setCondRulesStatus(['formFieldStatuses', ...path, col.id, index], ruleStatus, isChanged))
    }

    return {
      ruleStatus: ruleStatus,
      status: ruleStatus.status,
      error: labelField + ' ' + errorMessage,
      errorCode,
    }
  }

export const processLoginValueRules =
  (value, rules = [], label, isMandatory = true, isLogin = false, extra = {}) =>
  (dispatch, getAppState) => {
    let state = getAppState()
    let portalState = getState(state)

    let mandatoryProjectCaption = state.getIn(['project', 'Settings', 'captions', 'Mandatory'], 'is mandatory field')
    mandatoryProjectCaption =
      mandatoryProjectCaption === null || mandatoryProjectCaption === undefined
        ? 'is mandatory field'
        : mandatoryProjectCaption

    let elementCaptionMandatory = state.getIn(['project', 'ProfileCaptions', 'is mandatory'], false)
    let invalidProjectCaption = state.getIn(['project', 'Settings', 'captions', 'Invalid Value'], 'invalid value')
    let invalidEmailCaption = state.getIn(['session', 'captions', 'Invalid email address'], 'Invalid email address')
    if (isLogin) {
      elementCaptionMandatory = state.getIn(['session', 'captions', 'is mandatory'], false)
      invalidProjectCaption = state.getIn(['session', 'captions', 'Invalid Value'], 'invalid value')
    }
    const mandatoryCaption = elementCaptionMandatory ? elementCaptionMandatory : mandatoryProjectCaption

    let isError = false,
      errorMessage = ''
    let errorCode = ''

    const params = getParams(state)
    const smartVParams = typeof window !== 'undefined' ? _.get(getPreviewDynamicData(), 'svParams', {}) : {}

    if (isMandatory && !_.trim(value)) {
      isError = true
      errorMessage = `${label} ${mandatoryCaption}`
      errorCode = 'mandatory'
    } else if (extra?.field?.type === 'email') {
      if (isMandatory || value) {
        if (!isEmailValid(value)) {
          isError = true
          errorMessage = invalidEmailCaption
        }
      }
    }

    if (!isError && _.size(rules) > 0) {
      for (let i = 0; i < rules.length; i++) {
        _.each(rules[i].conditions, (cond) => {
          _.set(cond, 'field.value', 'loginField')
          if (value !== undefined) {
            portalState = _.set(portalState, ['loginField'], value)
          }
        })
        if (rules[i].enable === false) {
          break
        }
        const ruleRunResult = processRuleCondition(
          rules[i].conditions,
          portalState,
          params,
          smartVParams,
          null,
          {},
          false,
          {},
          {},
          state
        )

        if (!ruleRunResult) {
          isError = true
          errorMessage = rules[i].message
          break
        }
      }
    }
    let ruleStatus = {}
    if (isError) {
      ruleStatus.status = 'error'
      ruleStatus.error = errorMessage
      ruleStatus.errorCode = errorCode
    } else {
      ruleStatus.status = 'success'
      ruleStatus.error = ''
      ruleStatus.errorCode = ''
    }

    return {
      ruleStatus: ruleStatus,
      status: ruleStatus.status,
      error: errorMessage,
      errorCode,
    }
  }

export const recursiveChkParentVisible = (elements, parent, rules, elemUID, repeatIndex) => {
  if (!rules) {
    return false
  }
  const indexPath = repeatIndex !== null && repeatIndex !== undefined ? [repeatIndex] : []
  try {
    let actions = rules.getIn([parent, ...indexPath], List()).toJS()
    if (actions.indexOf('hide') > -1) {
      return true
    }
    if (elements.getIn([parent, 'type']) == 'Form') {
      let form = elements.getIn([parent])
      let children = form.getIn(['props', 'lg', 'children'], List()).toJS()
      let isInvisible = false
      _.each(children, function (row, rowID) {
        if (row) {
          _.each(row.children, function (col, colID) {
            if (col && col.children && !isInvisible) {
              if (col.children.indexOf(elemUID) > -1) {
                try {
                  let actionsRow = rules.getIn([parent + '-row', rowID], List()).toJS()
                  if (actionsRow.indexOf('hide') > -1) {
                    isInvisible = true
                  } else {
                    let actionsCell = rules.getIn([parent + '-cell', colID], List()).toJS()
                    if (actionsCell.indexOf('hide') > -1) {
                      isInvisible = true
                    } else {
                      let actionsCol = rules.getIn([parent + '-col', `c${col.index}`], List()).toJS()
                      if (actionsCol.indexOf('hide') > -1) {
                        isInvisible = true
                      }
                    }
                  }
                } catch (err) {
                  console.error(err)
                }
              }
            }
          })
        }
      })

      if (isInvisible) {
        return true
      }
    }
    if (elements.getIn([parent, 'parent'])) {
      return recursiveChkParentVisible(elements, elements.getIn([parent, 'parent']), rules, parent, repeatIndex)
    }
  } catch (err) {}

  return false
}

function setMandatoryErrorData(errorData = {}, mandatoryCaption = '') {
  Object.assign(errorData, {
    isError: true,
    errorMessage: mandatoryCaption,
    errorCode: 'mandatory',
  })
}
export const processValueRules =
  (uid, component, getRepeatPath, repeatIndex, value, pathToRules, typeEvent, currentStatus, isImmediate = false) =>
  (dispatch, getAllState) => {
    let state = getAllState()
    if (!component) {
      component = Map()
    }
    if (typeof getRepeatPath === 'function' && value !== undefined) {
      const statePath = getRepeatPath('state')
      if (value && value.ftListValue !== undefined && statePath.includes('ftListValue')) {
        state = state.setIn(statePath, value.ftListValue)
      } else if (component.getIn(['props', 'control']) === 'currency' && _.last(statePath) === 'value') {
        state = state.setIn(_.initial(statePath), fromJS(value))
      } else {
        state = state.setIn(statePath, fromJS(value))
      }
    }
    const defMandatory = 'is mandatory field'
    const mandatoryProjectCaption =
      state.getIn(['project', 'Settings', 'captions', 'Mandatory'], defMandatory) || defMandatory
    const mandatoryCaption = component.getIn(['props', 'captions', 'Mandatory']) || mandatoryProjectCaption
    const defInvalid = 'invalid value'
    const invalidProjectCaption =
      state.getIn(['project', 'Settings', 'captions', 'Invalid Value'], defInvalid) || defInvalid
    const invalidCaption = component.getIn(['props', 'captions', 'Invalid Value']) || invalidProjectCaption

    let portalState = getState(state)
    if (value === undefined) {
      let fieldValues = {}
      _.each(portalState, function (page) {
        fieldValues = {
          ...fieldValues,
          ...page,
        }
      })
      if (typeof getRepeatPath === 'function') {
        value = _.get(portalState, _.tail(getRepeatPath()), fieldValues[uid])
      } else {
        value = fieldValues[uid]
      }
    }

    const errorData = {
      isError: false,
      errorMessage: '',
      errorCode: '',
    }
    const layoutMode = state.getIn(['layoutMode'], 'lg')
    const fieldProps = getValueForMode(component, layoutMode, ['props'], [], Map()).toJS()

    let page = state.getIn(['page'])
    let parentUID = component.getIn(['parent'])
    let rootParentID = getParentIdInModal(
      state,
      component.get('parent'),
      getPageUID(page, state.getIn(['project', 'Pages']))
    )
    let isVisible = true
    let isInvisibleParent = false

    const collectChildID = (root, id) => {
      let elem = state.getIn([...root, 'elements', id], Map())
      let child = []
      if (elem.get('type') === 'Form') {
        _.each(LAYOUT_MODE, (mode) => {
          const childList = elem.getIn(['props', mode, 'children'], Map())
          if (isImmutable(childList)) {
            childList.map((row) => {
              row.get('children', Map()).map((col) => {
                if (col && List.isList(col.get('children', List()))) {
                  child = [...child, ...col.get('children', List()).toJS()]
                }
              })
            })
          }
        })
      } else if (TAB_TYPES.includes(elem.get('type'))) {
        _.each(LAYOUT_MODE, (mode) => {
          const tabs = elem.getIn(['props', mode, 'tabs'], List()).toJS()
          child = [...child, ..._.flatMap(tabs, (tab) => tab.children)]
        })
      } else {
        if (isImmutable(elem.get('children', List()))) {
          elem.get('children', List()).map((childList) => {
            if (List.isList(childList)) {
              child = [...child, ...childList.toJS()]
            } else {
              child.push(childList)
            }
          })
        }
      }
      return [...child, ..._.flatMap(child, (uid) => collectChildID(root, uid))]
    }

    if (parentUID) {
      let parent = state.getIn(['pages', page, 'Props', 'elements', parentUID])
      if (parent) {
        let elem = parent.toJS()
        let pageUID = getPageUID(page, state.getIn(['project', 'Pages']))
        isInvisibleParent = recursiveChkParentVisible(
          state.getIn(['pages', page, 'Props', 'elements']),
          parentUID,
          state.getIn(['rules', pageUID]),
          uid
        )
        if (elem && TAB_TYPES.indexOf(elem.type) > -1) {
          let allElementsInsideForm = []

          let tabs = _.get(elem, ['props', layoutMode, 'tabs'])
          if (tabs) {
            _.each(tabs, function (tab) {
              if (tab && tab.children) {
                if (tab.children.indexOf(uid) > -1) {
                  let tabRules = state.getIn(['rules', pageUID, `${parentUID}-tab`, tab.id], List())
                  if (tabRules && tabRules.indexOf('hide') > -1) {
                    isInvisibleParent = true
                    isVisible = false
                  }
                }
                allElementsInsideForm = _.concat(tab.children, allElementsInsideForm)
              }
            })
          }
          const root = getElementDataRoot(page)
          allElementsInsideForm = [
            ...allElementsInsideForm,
            ..._.flatMap(allElementsInsideForm, (uid) => collectChildID(root, uid)),
          ]
          if (uid && allElementsInsideForm.indexOf(uid) == -1) {
            isVisible = false
          }
        } else if (elem && elem.type == 'Form') {
          let allElementsInsideForm = []

          let child = _.get(elem, ['props', layoutMode, 'children'])
          if (child) {
            _.each(child, function (row) {
              if (row && row.children) {
                _.each(row.children, function (col) {
                  if (col && col.children) {
                    allElementsInsideForm = _.concat(col.children, allElementsInsideForm)
                  }
                })
              }
            })
          }
          if (uid && allElementsInsideForm.indexOf(uid) == -1) {
            isVisible = false
          }
        }
      }
    }

    if (!isVisible) {
      return {
        ruleStatus: true,
        status: false,
      }
    }

    let rulesPath

    if (isImmutable(pathToRules)) {
      pathToRules = pathToRules.toJS()
    }

    if (typeof getRepeatPath === 'function') {
      rulesPath = getRepeatPath('rules')
      if (isImmutable(rulesPath)) {
        rulesPath = rulesPath.toJS()
      }
      rulesPath = [..._.compact(rulesPath)]
      rulesPath[0] = 'rules'
    } else if (pathToRules && _.isArray(pathToRules)) {
      rulesPath = [..._.compact(pathToRules)]
      rulesPath[0] = 'rules'
    }

    if (rulesPath) {
      let control = component.getIn(['props', 'control'], 'text')
      if (_.last(rulesPath) === 'value') {
        rulesPath = _.initial(rulesPath)
      } else if (_.includes(rulesPath, 'value') && control == 'currency') {
        rulesPath = _.filter(rulesPath, (v) => v !== 'value')
      }
      let actions = state.getIn(rulesPath, List())
      if (actions && isImmutable(actions)) {
        actions = actions.toJS()
      } else {
        actions = []
      }

      const elementType = component.get('type')

      if (COMPLEX_ELEMENT_TYPES.includes(elementType)) {
        actions = getActionsForComplexElements(actions)
      }

      if (_.isArray(actions)) {
        if (actions.indexOf('hide') > -1 || isInvisibleParent) {
          return {
            ruleStatus: {
              status: 'success',
              error: '',
              errorCode: '',
            },
            status: false,
          }
        } else if (actions.indexOf('mandatory') > -1) {
          fieldProps.mandatory = true
        } else if (actions.indexOf('notMandatory') > -1) {
          fieldProps.mandatory = false
        }
      }
    }

    if (fieldProps.mandatory) {
      let isListCheckbox = false
      let control = component.getIn(['props', 'control'], 'text')
      if (control == 'checkbox') {
        isListCheckbox = component.getIn(['props', 'source'], 'single') !== 'single'
      }
      if (component.getIn(['type']) == 'SurveyList') {
        isListCheckbox = true
      }
      if (LIST_BASED_FIELDS.indexOf(control) > -1 || isListCheckbox) {
        if (typeof value == 'string' && value) {
          errorData.isError = false
        } else if (!value || !value.ftListValue) {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else if (control == 'checkbox') {
        if (value !== true && value !== 'true') {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else if (control == 'lookup') {
        if (!value || !value.ft_value) {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else if (component.getIn(['type']) == 'Matrix') {
        let questions = component.getIn(['props', 'questions'], List())
        if (isImmutable(questions)) {
          questions.map((row) => {
            if (isImmutable(value)) {
              if (value.get(row.get('uid')) === undefined) {
                setMandatoryErrorData(errorData, mandatoryCaption)
              }
            } else {
              if (!value || !value[row.get('uid')]) {
                setMandatoryErrorData(errorData, mandatoryCaption)
              }
            }
          })
        }
      } else if (component.getIn(['props', 'control'], 'text') == 'currency') {
        if (
          value !== 0 &&
          (!value || (_.isObject(value) && (value.value === '' || value.value === undefined || value.value === null)))
        ) {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else if (control === 'fileupload') {
        let files = !IS_SERVER && window?.__FT_PROJECT__API__?.getFilesByID?.(uid, repeatIndex)
        if (!files || _.size(files) === 0) {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else if (component.getIn(['props', 'control'], 'text') == 'number') {
        if (value === '' || value === undefined || value === null) {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else if (component.getIn(['type']) == 'Range') {
        if (isImmutable(value)) {
          value = value.toJS()
        }
        if (!value) {
          errorData.isError = true
        }
        if (!errorData.isError) {
          if (value.min === '' || value.min === undefined || value.min === null) {
            errorData.isError = true
          }
          if (value.max === '' || value.max === undefined || value.max === null) {
            errorData.isError = true
          }
        }
        if (errorData.isError) {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else if (control === 'switch') {
        if (value === undefined || value === null || value === '' || value === false) {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else if (component.get('type') === 'TextReview') {
        const textReviewState = value

        if (!textReviewState.changesNumber && !textReviewState.value) {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      } else {
        if (value === undefined || value === null || value === '') {
          setMandatoryErrorData(errorData, mandatoryCaption)
        }
      }
    }
    if (!errorData.isError) {
      if (component.getIn(['props', 'control'], 'text') == 'url') {
        if (value) {
          var RegExp =
            /^((https|http|ftp):\/\/)?(www.)?([a-zA-Z0-9])+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,5})?(\/[^\s]*)?/gim
          if (!RegExp.test(String(value).toLowerCase())) {
            errorData.isError = true
            errorData.errorMessage = invalidCaption
          }
        }
      } else if (component.getIn(['props', 'control'], 'text') == 'email') {
        if (value) {
          if (!isEmailValid(value)) {
            errorData.isError = true
            errorData.errorMessage = invalidCaption
          }
        }
      } else if (['time', 'date', 'datetime'].includes(component.getIn(['props', 'control'], 'text'))) {
        if (value === 'Invalid date') {
          errorData.isError = true
          errorData.errorMessage = invalidCaption
        }
      } else if (
        component.getIn(['props', 'control'], 'text') == 'number' ||
        component.getIn(['type']) === 'TextCounter'
      ) {
        if (value !== '' && value !== undefined && value !== null) {
          let localValue = parseFloat(value)
          if (isNaN(localValue)) {
            errorData.isError = true
            errorData.errorMessage = invalidCaption
          } else {
            let minValue = parseFloat(fieldProps.minVal)
            let maxValue = parseFloat(fieldProps.maxVal)
            if (!isNaN(minValue)) {
              if (minValue > value) {
                errorData.isError = true
                errorData.errorMessage = invalidCaption
              }
            }

            if (!isNaN(maxValue)) {
              if (maxValue < value) {
                errorData.isError = true
                errorData.errorMessage = invalidCaption
              }
            }
          }
        }
      }
    }

    if (!errorData.isError) {
      const params = getParams(state)
      const smartVParams = typeof window !== 'undefined' ? _.get(getPreviewDynamicData(), 'svParams', {}) : {}
      let rules = component.getIn(['props', 'valueRule'], List()).toJS()
      if (repeatIndex === undefined) {
        repeatIndex = null
      }
      if (component.getIn(['props', 'valueRule'], List()).size) {
        for (let i = 0; i < rules.length; i++) {
          if (rules[i].enable !== false) {
            let ruleRunResult
            try {
              if (rules[i].conditions.length == 1) {
                if (rules[i].conditions[0].operator == 'geolocation') {
                  if (typeEvent) {
                    if (typeEvent == 'addressSelection') {
                      ruleRunResult = true
                    } else if (typeEvent == 'sfValidation') {
                      if (isImmutable(currentStatus)) {
                        currentStatus = currentStatus.toJS()
                      }
                      if (currentStatus && currentStatus.status == 'success') {
                        ruleRunResult = true
                      }
                    }
                  }
                }
              }
            } catch (err) {
              console.error(err)
            }
            if (!ruleRunResult) {
              let stripComponent = state.getIn(['pages', page, 'Props', 'elements', rootParentID], Map())
              const isRepeat = stripComponent.getIn(['props', 'isRepeat'], false)
              const isRepeatCol = stripComponent.getIn(['props', 'isRepeatCol'], false)
              if (
                typeof getRepeatPath === 'function' &&
                repeatIndex !== undefined &&
                repeatIndex !== null &&
                (isRepeat || isRepeatCol)
              ) {
                _.each(rules[i].conditions, (cond) => {
                  try {
                    let field = String(cond.field?.value).split(':')
                    let path = getRepeatPath('state')
                    if (field[1] !== path[2]) {
                      field.splice(1, 0, path[2])
                      cond.field.value = field.join(':')
                    }
                  } catch (error) {
                    console.error(error)
                  }
                })
              }
              ruleRunResult = processRuleCondition(
                rules[i].conditions,
                portalState,
                params,
                smartVParams,
                repeatIndex,
                {},
                false,
                {},
                {},
                state
              )
            }
            if (!ruleRunResult) {
              errorData.isError = true
              errorData.errorMessage = rules[i].message
              break
            }
          }
        }
      }
    }
    let labelField = fieldProps.label || ''
    let ruleStatus = {}
    if (errorData.isError) {
      ruleStatus.status = 'error'
      ruleStatus.error = errorData.errorMessage
      ruleStatus.errorCode = errorData.errorCode
    } else {
      ruleStatus.status = 'success'
      ruleStatus.error = ''
      ruleStatus.errorCode = ''
    }
    if (dispatch && typeof getRepeatPath === 'function') {
      const path = _.compact(getRepeatPath('formFieldStatuses'))
      if (path.length === 1) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Error while trying to set rules for ', uid, repeatIndex, pathToRules)
        }
      } else {
        if (isImmediate) {
          dispatch({
            type: COND_RULES_SET_STATUS,
            payload: {
              path: getRepeatPath('formFieldStatuses'),
              status: ruleStatus,
            },
          })
        } else {
          dispatch(setCondRulesStatus(getRepeatPath('formFieldStatuses'), ruleStatus))
        }
      }
    }

    return {
      ruleStatus: ruleStatus,
      status: errorData.isError,
      error: _.trim(labelField + ' ' + errorData.errorMessage),
      errorCode: errorData.errorCode,
    }
  }

const getActionsForComplexElements = (actions) => {
  if (_.isArray(actions)) {
    return actions
  }

  const elementCommonActions = _.get(actions, '0')

  return _.isArray(elementCommonActions) ? elementCommonActions : actions
}
